<template>
  <div>
    <!-- <AutoLogout /> -->
    <h3 class="header-title">Hi, Welcome On {{ user.name }} !</h3>
    <label>What do you want to do today?</label>
    <br />
    <label
      >

      You have subscribed to the {{ user.packageName }} package, which is valid until  {{ user.validTo }}. This subscription comes at a price of RM {{ user.invoiceprice }} and 
      includes a limit of {{ check.NumberOfStudent }} students and <span v-if="check.TotalTeacher === 0">Unlimited</span><span v-else>{{ check.TotalTeacher }} </span> teachers.
      
      </label
    >
    <br />
    <div class="custom-explore">
      <div>
        <CRow>
          <CCol sm="12">
            <div style="width: 80%" class="float-left">
              <img
                src="../assets/img/iconnoti.svg"
                class="ml-5 mr-2 mb-3 mt-3"
              />
              <span class="text-white mt-3 mb-2"> | </span>
              <label class="ml-2 text-white mt-3 mb-2"
                >Explore more on your pesonal dashboard!</label
              >
            </div>
            <div style="width: 20%" class="float-right p-0">
              <br /><br />
              <img
                src="../assets/img/icontriangle.svg"
                class="ml-5 mr-2"
                style="
                  position: absolute;
                  top: 0;
                  right: 100px;
                  bottom: 0;
                  height: 55px;
                "
              />
            </div>
          </CCol>
        </CRow>
      </div>
    </div>
    <div v-if="user.validTo < currentDate" class="mt-2">
      <CAlert show color="danger">
        <CRow>
          <CCol sm="10">
            <strong class="text-danger mr-2"
          >X ERROR ! Your subscription package has expired. Please renew your
          current subscription or upgrade to a new package.
        </strong>
          </CCol>
          <CCol sm="2" class="text-right">
            <CButton type="button" class="custom-btn-navy" @click="GoToRenew()">Renew</CButton>
          </CCol>

        </CRow>
       
      </CAlert>
    </div>
    <CRow class="mt-3">
      <CCol sm="2">
        <CCard style="height: 100px" @click="GoToOldSubject()" class="pointer">
          <div class="text-center p-2">
            <br />
            <img
              style="max-height: 30px"
              src="../assets/img/listsubject.svg"
              class="pointer"
            />
            <br />
            <label class="pointer">List Subject</label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="2">
        <CCard style="height: 100px" @click="GoToOldPackage()" class="pointer">
          <br />
          <div class="text-center p-2">
            <img
              style="max-height: 30px"
              src="../assets/img/listpackage.svg"
              class="pointer"
            />
            <br />
            <label class="pointer">List Package</label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="2">
        <CCard style="height: 100px" @click="GoToOldStudent()" class="pointer">
          <br />
          <div class="text-center p-2">
            <img
              style="max-height: 30px"
              src="../assets/img/liststudent.svg"
              class="pointer"
            />
            <br />
            <label class="pointer">List Student</label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="2">
        <CCard style="height: 100px" @click="GoToOldTeacher()" class="pointer">
          <br />
          <div class="text-center p-2">
            <img
              style="max-height: 30px"
              src="../assets/img/listteacher.svg"
              class="pointer"
            />
            <br />
            <label class="pointer">List Teacher</label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="2">
        <CCard
          style="height: 100px"
          @click="GoToOldStudentAttendance()"
          class="pointer"
        >
          <div class="text-center p-2">
            <img
              style="max-height: 30px"
              src="../assets/img/listattendancestudent.svg"
              class="pointer"
            />
            <br />
            <label class="pointer"
              >List Attendance <br />
              Student</label
            >
          </div>
        </CCard>
      </CCol>
      <CCol sm="2">
        <CCard
          style="height: 100px"
          @click="GoToOldTeacherAttendance()"
          class="pointer"
        >
          <div class="text-center p-2">
            <img
              style="max-height: 30px"
              src="../assets/img/listattendanceteacher.svg"
              class="pointer"
            />
            <br />
            <label class="pointer">List Attendance <br />Teacher</label>
          </div>
        </CCard>
      </CCol>
    </CRow>
    <CRow class="mt-1">
      <CCol sm="6">
        <CCard class="custom-card-advertise mb-5" style="margin-left: 0px">
          <img
            src="../assets/img/imgvectorteacher.svg"
            style="border-radius: 15px; height: 350px"
            class="custom-bg-advetise"
          />
          <div class="bg-linear">
            <h3 class="custom-text-adv ml-2">
              Want to add a new student to <br />your tuition centre?
            </h3>
            <label class="custom-label-text ml-2">Add Student </label>
            <br />

            <label class="float-right custom-label-text mr-2 mt-1"> </label>
          </div>
        </CCard>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol sm="6">
            <CCard>
              <div style="height: 160px">
                <h5 class="custom-subtitle-card m-2">Pending Payment</h5>
                <h3 class="custom-32px mt-3 ml-2 mt-3 text-danger-custom">
                  {{ user.currencyCode }} {{ paid.TotalUnpaid }}
                </h3>
              </div>
            </CCard>
            <CCard>
              <div style="height: 160px">
                <h5 class="custom-subtitle-card m-2">Salary Summary</h5>
                <h3 class="custom-32px mt-3 ml-2 mt-3 text-success">
                  {{ user.currencyCode }} {{ paid.TotalPaid }}
                </h3>
              </div>
            </CCard>
          </CCol>
          <CCol sm="6">
            <CCard>
              <div style="height: 160px">
                <h5 class="custom-subtitle-card m-2">Number of Students</h5>
                <h3 class="custom-32px mt-3 ml-2 mt-3">{{ students }}</h3>
              </div>
            </CCard>
            <CCard>
              <div style="height: 160px">
                <h5 class="custom-subtitle-card m-2">Number of Teachers</h5>
                <h3 class="custom-32px mt-3 ml-2 mt-3">{{ teachers }}</h3>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CCol>
    </CRow>

    <CRow class="mt-1">
      <CCol sm="12">
        <CRow>
          <CCol sm="4">
            <CCard>
              <h5 class="custom-subtitle-card m-2">Today Classes</h5>
              <div class="custom-height-card" style="overflow-y: scroll">
                <div v-for="item in schedule" v-bind:key="item.Id" class="p-2">
                  <h5 class="custom-24px">{{ item.SubjectName }}</h5>
                  <h6>
                    {{ item.Start | moment("HH:mm") }} -
                    {{ item.End | moment("HH:mm") }}
                  </h6>
                  <h6>{{ item.Teacher }}</h6>
                </div>
              </div>
            </CCard>
          </CCol>
          <CCol sm="8">
            <CCard>
              <div class="custom-height-card">
                <h5 class="custom-subtitle-card m-2">Class Overview</h5>
                <div class="p-1">
                  <canvas
                    style="width: 326px; height: 350px"
                    id="myChartSchedule"
                  ></canvas>
                </div>
              </div>
            </CCard>
          </CCol>
        </CRow>
      </CCol>
      <!-- <CCol sm="4">
        <CCard>
          <div class="custom-height-card">
            <h5 class="custom-subtitle-card m-2">Chat</h5>
            <div v-for="(item,index) in askiddo" v-bind:key="item.Id">
                <CRow class="m-2">
                  <CCol sm="2">
                    <img v-if="item.ProfilePicturePath==='empty'" style="border: 1px solid #eee;width: 50px;
                        height: 50px;
                        object-fit: cover;
                        border-radius: 50%;
                      "
                      src="../assets/img/default.png"
                      class="grey lighten-2 mt-2"
                    />

                    <img
                      v-else
                      style="border: 3px solid #ddd;
                        background: #fff;
                        width: 50px;
                        height: 50px;
                        object-fit: cover;
                        border-radius: 50%;
                      "
                      :src="getPicChild(index)"
                      class="grey lighten-2 mt-2"
                    />
                  </CCol>
                  <CCol sm="10">
                    <label class="small mt-2"><b> {{ item.UserName }}</b><br />
                     {{ item.CreatedTime | moment("MMM DD, YYYY") }} | {{ item.CreatedTime | moment("hh:mm") }}</label>
                  </CCol>
                  <CCol sm="12">
                    <label class="small">{{ item.Content }}</label>
                  </CCol>
                </CRow>
            </div>
          </div>
        </CCard>
      </CCol> -->
    </CRow>

    <CRow class="mt-1">
      <CCol sm="8">
        <CCard>
          <div style="height: 450px">
            <h5 class="custom-subtitle-card m-2">Attendance Overview</h5>
            <CChartLine
              style="height: 300px; margin-top: 40px"
              :labels="attendanceChartLabel"
              :datasets="attendanceDatasets"
              :options="{
                responsive: true,
                maintainAspectRatio: false,
              }"
            />

            <canvas style="width: 326px; height: 350px" id="lineChart"></canvas>
          </div>
        </CCard>
      </CCol>
      <CCol sm="4">
        <CCard>
          <div style="height: 450px">
            <h5 class="custom-subtitle-card m-2">Announcement</h5>

            <div v-for="item in announcement" v-bind:key="item.Id">
              <h5 class="custom-18px ml-2">New Announcement</h5>
              <label class="small text-muted ml-2">
                {{ item.dataMessage }}
                <br />
                {{ item.name }} |
                {{ item.createdTime | moment("MMM DD YYYY hh:mm") }}
              </label>
            </div>
          </div>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>


<script>
import Vue from "vue";
import FullCalendar from "vue-full-calendar";
import "fullcalendar/dist/fullcalendar.css";
import backgroundUrl from "../assets/img/bgtips.png";

import _ from "lodash";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import { CChartBar } from "@coreui/vue-chartjs";
import { CChartLine } from "@coreui/vue-chartjs";
import VueEllipseProgress from "vue-ellipse-progress";

//import "@fullcalendar/core/vdom"; // solves problem with Vite]
import AutoLogout from './AutoLogout.vue';

import { Calendar } from "vue-sweet-calendar";
import "vue-sweet-calendar/dist/SweetCalendar.css";
import { getColor, deepObjectsMerge } from "@coreui/utils/src";

Vue.use(FullCalendar);
Vue.use(VueEllipseProgress);

export default {
  name: "Collapses",
  components: {
    PulseLoader,
    CChartBar,
    Calendar,
    CChartLine,
    AutoLogout
  },

  data() {
    return {
      backgroundUrl,
      user: {},
      subject: [],
      students: 0,
      schedule: [],
      paid: {},
      chartLabel: [],
      week: [],
      askiddo: [],
      countByDay: [],
      attendanceChartLabel: [],
      attendanceDatasets: [
        {
          label: "Teacher",
          backgroundColor: "#df4018",
          borderColor: "#df4018",
          pointBackgroundColor: "#df4018",
          pointBorderColor: "#df4018",
          data: [],
          fillOpacity: .3,
        },
        {
          label: "Student",
          backgroundColor: "#ee8865",
          borderColor: "#ee8865",
          pointBackgroundColor: "#ee8865",
          pointBorderColor: "#fff",
          data: [],
          fillOpacity: .3,
        },
      ],
      announcement: [],

      check: {},
      currentDate: new Date().toISOString().substring(0, 10),
    };
  },
  async mounted() {
    this.SessionUserIdNo();
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.SessionUserIdNo();
      this.GetStudent();
      this.GetTeacher();
      this.GetSchedule();
      this.GetTotalPaidUnpaid();
      this.GetScheduleCurrentWeek();
      this.GetAskKiddo();
      this.GetScheduleWeek();
      this.GetCreatedAttendance();
      this.GetAnnouncement();
      this.GetCheckTc();
      this.SessionUserIdNo();
    } else {
      this.GoToLogin();
    }
  },
  computed: {
    defaultDatasets() {
      return [
        {
          data: this.dataPoints,
          backgroundColor: getColor(this.backgroundColor),
          pointHoverBackgroundColor: getColor(this.pointHoverBackgroundColor),
          label: this.label,
          barPercentage: 0.5,
          categoryPercentage: 1,
        },
      ];
    },
    attendanceChartLabel: [],
    attendanceDatasets: [
      {
        label: "Teacher",
        data: [],
      },
      {
        label: "Student",
        data: [],
      },
    ],
  },

  methods: {
    SessionUserIdNo() {
      return this.$API
        .get(this.$LoginUserDetailAdmin, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetStudent();
            this.GetTeacher();
            this.GetSchedule();
            this.GetTotalPaidUnpaid();
            this.GetScheduleCurrentWeek();
            this.GetAskKiddo();
            this.GetScheduleWeek();
            this.GetCreatedAttendance();
            this.GetAnnouncement();
            console.log(":testing" + this.user.id);
            this.GetCheckTc(this.user.tuitioncenter);

            if(this.user.invoicepaidts == null)
            {
              this.GoToLogin();

            }
          }
        });
    },
    GetCheckTc(tuitioncenter) {
      return this.$API
        .get(this.$GetCheckTcPackage + "?TuitionCenterId=" + tuitioncenter, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.check = response.data;
          }
        });
    },
    GetScheduleCurrentWeek() {
      this.$API
        .get(this.$ScheduleStudent, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.week = response.data;
          }
        });
    },
    GetSubjectCount() {
      return this.$API
        .get(this.$GetListSubjectTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.subject = response.data;
          }
        });
    },
    GetStudent() {
      this.Busy = true;
      this.$API
        .get(this.$ViewStudentCount, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.students = response.data;
          }
        });
    },
    GetTeacher() {
      this.Busy = true;
      this.$API
        .get(this.$ViewTeacherCount, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.teachers = response.data;
          }
        });
    },
    GetSchedule() {
      this.Busy = true;
      this.$API
        .get(this.$ScheduleStudentWebAll, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.schedule = response.data;
          }
        });
    },
    GetTotalPaidUnpaid() {
      this.Busy = true;
      this.$API
        .get(this.$TotalPaidAndUnpaidByTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.paid = response.data;
          }
        });
    },
    GetAskKiddo() {
      this.$API
        .get(this.$AskiddoListAll, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.askiddo = response.data;
            this.getPicChild(this.askiddo);
          }
        });
    },
    getPicChild(index) {
      return "https://pickiddo.com" + this.askiddo[index].ProfilePicturePath;
    },
    GetScheduleWeek() {
      this.$API
        .get(this.$ScheduleByWeek, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.countByDay = response.data;
            console.log("tets" + this.countByDay);

            var chartDatas = {
              datasets: [
                {
                  label: "M",
                  backgroundColor: "#007CEF",
                  data: [this.countByDay.monCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
                {
                  label: "T",
                  backgroundColor: "#FF7723",
                  data: [this.countByDay.tuesCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
                {
                  label: "W",
                  backgroundColor: "#8E30FF",
                  data: [this.countByDay.wedCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
                {
                  label: "T",
                  backgroundColor: "#8BAC54",
                  data: [this.countByDay.thuCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
                {
                  label: "F",
                  backgroundColor: "#D7F4DC",
                  data: [this.countByDay.friCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
                {
                  label: "S",
                  backgroundColor: "#321C41",
                  data: [this.countByDay.satCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
                {
                  label: "S",
                  backgroundColor: "#0263FF",
                  data: [this.countByDay.sunCount],
                  borderWidth: 2,
                  borderRadius: 50,
                },
              ],
            };

            // var barOption = {
            //   scaleStartValue: -10,
            //   responsive: true,
            //   maintainAspectRatio: false,
            //   legend: {
            //     position: "top", // place legend on the right side of chart
            //   },
            //   options: {
            //     layout: {
            //       padding: {
            //         left: 50,
            //         right: 0,
            //         top: 0,
            //         bottom: 0,
            //       },
            //     },
            //     borderRadius: 20,
            //     responsive: true,
            //     maintainAspectRatio: false,
            //   },
            //   events: false,
            //   showTooltips: true,
            //   barValueSpacing: 50,
            //   scales: {
            //     xAxes: [
            //       {
            //         gridLines: {
            //           offsetGridLines: false,
            //         },
            //       },
            //     ],
            //     yAxes: [
            //       {
            //         ticks: {
            //           min: 0,
            //         },
            //         gridLines: {
            //           offsetGridLines: false,
            //         },
            //       },
            //     ],
            //   },
            //   elements: {
            //     rectangle: {
            //       borderRadius: 20,
            //     },
            //   },
            //   animation: {
            //     duration: 100,
            //     easing: "easeOutQuart",
            //     onComplete: function () {
            //       var chartInstance = this.chart,
            //         ctx = chartInstance.ctx;

            //       ctx.font = Chart.helpers.fontString(
            //         Chart.defaults.global.defaultFontSize,
            //         Chart.defaults.global.defaultFontStyle,
            //         Chart.defaults.global.defaultFontFamily
            //       );
            //       ctx.textAlign = "center";
            //       ctx.textBaseline = "bottom";
            //       ctx.font = "600 10px Verdana";

            //       this.data.datasets.forEach(function (dataset, i) {
            //         var meta = chartInstance.controller.getDatasetMeta(i);
            //         meta.data.forEach(function (bar, index) {
            //           var data = dataset.data[index];
            //           ctx.fillText(data, bar._model.x, bar._model.y + 17);
            //           ctx.borderRadius = 50;
            //         });
            //       });

            //       var ctx = this.chart.ctx;
            //       ctx.font = Chart.helpers.fontString(
            //         Chart.defaults.global.defaultFontFamily,
            //         "bold",
            //         Chart.defaults.global.defaultFontFamily
            //       );
            //       ctx.textAlign = "center";
            //       ctx.textBaseline = "end";
            //       ctx.font = "600 10px Verdana";

            //       this.data.datasets.forEach(function (dataset, i) {
            //         var meta = chartInstance.controller.getDatasetMeta(i);
            //         meta.data.forEach(function (bar, index) {
            //           var data = dataset.data[index];
            //           ctx.fillText(
            //             dataset.label,
            //             bar._model.x,
            //             bar._model.y + 1
            //           );
            //           ctx.borderRadius = 50;
            //         });
            //       });
            //     },
            //   },
            // };


            var barOption = {
  scaleStartValue: -10,
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    position: "top",
  },
  elements: {
    rectangle: {
      borderRadius: 20
    }
  },
  events: true,
  showTooltips: true,
  barValueSpacing: 50,
  scales: {
    xAxes: [{
      gridLines: {
        offsetGridLines: false
      }
    }],
    yAxes: [
      {
        ticks: {
          min: 0,
        },
        gridLines: {
          offsetGridLines: false
        }
      },
    ],
  },
  animation: {
    duration: 100,
    easing: "easeOutQuart",
    onComplete: function () {
      var chartInstance = this.chart,
        ctx = chartInstance.ctx;

      ctx.font = Chart.helpers.fontString(
        Chart.defaults.global.defaultFontSize,
        Chart.defaults.global.defaultFontStyle,
        Chart.defaults.global.defaultFontFamily
      );
      ctx.textAlign = "center";
      ctx.textBaseline = "bottom";
      ctx.font = "600 10px Verdana";

      this.data.datasets.forEach(function (dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function (bar, index) {
          var data = dataset.data[index];
          ctx.fillText(data, bar._model.x, bar._model.y + 17);
        });
      });

      var ctx = this.chart.ctx;
      ctx.font = Chart.helpers.fontString(
        Chart.defaults.global.defaultFontFamily,
        "bold",
        Chart.defaults.global.defaultFontFamily
      );
      ctx.textAlign = "center";
      ctx.textBaseline = "end";
      ctx.font = "600 10px Verdana";

      this.data.datasets.forEach(function (dataset, i) {
        var meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach(function (bar, index) {
          var data = dataset.data[index];
          ctx.fillText(
            dataset.label,
            bar._model.x,
            bar._model.y + 1
          );
        });
      });
    },
  },
};


            var ctx = document
              .getElementById("myChartSchedule")
              .getContext("2d");

            var myBar = new Chart(ctx, {
              type: "bar",
              data: chartDatas,
              options: barOption,
            });
          }
        });
    },
    GetCreatedAttendance() {
      this.$API
        .get(this.$AttendanceOverview, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.attendanceChartLabel = _.map(response.data, "CreatedDate");
            this.attendanceDatasets[0].data = _.map(
              response.data,
              "TotalAttendanceTeacher"
            );
            this.attendanceDatasets[1].data = _.map(
              response.data,
              "TotalAttendanceStudent"
            );
          }
        });
    },
    GetAnnouncement() {
      this.$API
        .get(this.$AllNotificationLimitAuthorizeByWebTc, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.announcement = response.data;
          }
        });
    },
    GoToOldSubject() {
      this.$router.push("TuitionSubject");
    },
    GoToOldPackage() {
      this.$router.push("TuitionPackage");
    },
    GoToOldStudent() {
      this.$router.push("TuitionStudent");
    },
    GoToOldTeacher() {
      this.$router.push("TuitionTeacher");
    },
    GoToOldStudentAttendance() {
      this.$router.push("TuitionAttendanceStudent");
    },
    GoToOldTeacherAttendance() {
      this.$router.push("TuitionAttendanceTeacher");
    },
    GoToRenew()
    {
      // window.open("https://www.pickiddo.com/RenewPackage?UserGroupId=" + this.user.usergroupId, "_blank");
      this.$router.push(
        "/Billing"
      );
    }
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@100&family=Montserrat&family=Poppins&display=swap");

.c-app {
  font-family: montserrat, Sans-serif;
}
.pointer {
  cursor: pointer;
}
</style>